import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
	searchEvents, searchByRegion, searchByCategory, fetchRegions
} from '../actions';

class EventSearchArea extends Component {
	constructor( props ) {
		super( props );
	}

	componentWillMount() {
		this.props.fetchRegions();
	}

	handleFormSubmit( event ) {
		event.preventDefault();
	}

	handleSearch( event ) {
		this.props.searchEvents( event.target.value );
	}

	handleRegionFilter( event ) {
		this.props.searchByRegion( event.target.value );
	}

	handleCategoryFilter( event ) {
		this.props.searchByCategory( event.target.value );
	}

	clearFilters( event ) {
		event.preventDefault();
		this.clearKeywordSearch( event );
		this.clearRegion( event );
		this.clearCategory( event );
	}

	clearRegion( event ) {
		this.props.searchByRegion( '' );
		document.getElementById( 'events-inner-page-region-filter' ).selectedIndex = 0;
	}

	clearCategory( event ) {
		this.props.searchByCategory( '' );
		document.getElementById( 'events-inner-page-category-filter' ).selectedIndex = 0;
	}

	clearKeywordSearch( event ) {
		this.props.searchEvents( '' );
	}

	renderRegions() {
		if ( this.props.regions.regions ) {
			return this.props.regions.regions.map( ( region, index ) => {
				return (
					<option key={ index } name={ region } value={ region }  dangerouslySetInnerHTML={{__html: region }}/>
				);
			} );
		}
	}

	renderCategories() {
		return this.props.categories.map( ( category, index ) => {
			return (
				<option key={ index } name={ category } value={ category }>{ category }</option>
			);
		} );
	}

	render() {
		return (
			<form id="events-inner-page-search" className="inner-page-search form-inline remove-border" role="search" aria-label="Event Filters Form" onSubmit={ this.handleFormSubmit.bind( this ) }>
				<div>
					<div className="form-group-category form-group col-xs-12 col-md-3">
						<label className="sr-only" htmlFor="events-inner-page-category-filter">Category Filter</label>
						<select className="form-control" id="events-inner-page-category-filter" onChange={ this.handleCategoryFilter.bind( this ) }>
							<option name="" value="">All Categories</option>
							{ this.renderCategories() }
						</select>
					</div>
					<div className="form-group-region form-group col-xs-12 col-md-3">
						<label className="sr-only" htmlFor="events-inner-page-region-filter">Region Filter</label>
						<select className="form-control" id="events-inner-page-region-filter" onChange={ this.handleRegionFilter.bind( this ) }>
							<option name="" value="">All Regions</option>
							{ this.renderRegions() }
						</select>
					</div>
					<div className="form-group-keyword form-group col-xs-12 col-md-4">
						<label className="search-label sr-only" htmlFor="events-inner-page-keyword-filter">Keyword Filter</label>
						<input type="search"
						       value={ this.props.searchTerm }
						       onChange={ this.handleSearch.bind( this ) }
						       className="form-control"
						       id="events-inner-page-keyword-filter"
						       placeholder="Filter by keyword" />
					</div>
					<div className="form-group-clear col-xs-12 col-md-2">
						<button type="button" id=""
						        className="btn-clear-inner-search"
						        onClick={ this.clearFilters.bind( this ) }
						        name="Clear all search filters">

							<i className="fa-regular fa-circle-xmark"></i> Clear
							filters
						</button>
					</div>
				</div>
			</form>
		);
	}
}

function mapStateToProps( { searchTerm, regions, regionTerm, categories, categoryTerm } ) {
	return {
		searchTerm, regions, regionTerm, categories, categoryTerm
	};
}

export default connect( mapStateToProps, {
	searchEvents, searchByRegion, searchByCategory, fetchRegions
} )( EventSearchArea );